import { jsxAsElement as jsx } from 'web-shared/src/lib/jsx';
import { TypedAttributes, TypedElement } from '../htmlElementTyped';
import { addHoverEffect } from '../old/utils';

interface Folders {
  name: string;
  start: number;
  end: number;
}

interface Table {
  name: string;
  icon: string;
  link?: string;
  isContinuation?: boolean;
  colour: string;
  folders: Folders[];
}

const tables: Table[] = [
  // {
  //   name: 'Normal1',
  //   icon: '☆',
  //   link: 'https://darksabun.github.io/table/archive/normal1',
  //   folders: [
  //     { name: '1', start: 1, end: 25 },
  //     { name: '2', start: 25, end: 35 },
  //     { name: '3', start: 35, end: 55 },
  //     { name: '4', start: 55, end: 85 },
  //     { name: '5', start: 85, end: 105 },
  //     { name: '6', start: 105, end: 125 },
  //     { name: '7', start: 125, end: 135 },
  //     { name: '8', start: 135, end: 160 },
  //     { name: '9', start: 160, end: 190 },
  //     { name: '10', start: 190, end: 220 },
  //     { name: '11', start: 220, end: 250 },
  //     { name: '12', start: 250, end: 260 },
  //   ],
  // },
  {
    name: 'Normal2',
    icon: '▽',
    link: 'https://rattoto10.jounin.jp/table.html',
    colour: '#ffe1c1',
    folders: [
      { name: '1', start: 1, end: 25 },
      { name: '2', start: 25, end: 35 },
      { name: '3', start: 35, end: 55 },
      { name: '4', start: 55, end: 85 },
      { name: '5', start: 85, end: 105 },
      { name: '6', start: 105, end: 125 },
      { name: '7', start: 125, end: 135 },
      { name: '8', start: 135, end: 160 },
      { name: '9', start: 160, end: 190 },
      { name: '10', start: 190, end: 220 },
      { name: '11', start: 220, end: 245 },
      { name: '11+', start: 245, end: 255 },
      { name: '12-', start: 255, end: 275 },
      { name: '12', start: 275, end: 290 },
    ],
  },
  {
    name: 'Stardust',
    icon: 'ξ',
    link: 'https://mqppppp.neocities.org/ChartView',
    colour: '#c2ebff',
    folders: [
      { name: '1', start: 1, end: 10 },
      { name: '2', start: 10, end: 20 },
      { name: '3', start: 20, end: 30 },
      { name: '4', start: 30, end: 40 },
      { name: '5', start: 40, end: 50 },
      { name: '6', start: 50, end: 60 },
      { name: '7', start: 60, end: 70 },
      { name: '8', start: 70, end: 80 },
      { name: '9', start: 80, end: 90 },
      { name: '10', start: 90, end: 100 },
      { name: '11', start: 100, end: 110 },
      { name: '12', start: 110, end: 120 },
      { name: '13', start: 120, end: 130 },
    ],
  },
  {
    name: 'Starlight',
    icon: 'sr',
    isContinuation: true,
    link: 'https://djkuroakari.github.io/starlighttable.html',
    colour: '#63ceff',
    folders: [
      { name: '1', start: 130, end: 140 },
      { name: '2', start: 140, end: 150 },
      { name: '3', start: 150, end: 160 },
      { name: '4', start: 160, end: 170 },
      { name: '5', start: 170, end: 180 },
      { name: '6', start: 180, end: 190 },
      { name: '7', start: 190, end: 200 },
      { name: '8', start: 200, end: 210 },
      { name: '9', start: 210, end: 220 },
      { name: '10', start: 220, end: 230 },
      { name: '11', start: 230, end: 240 },
      { name: '12', start: 240, end: 250 },
      { name: '13', start: 250, end: 260 },
    ],
  },
  {
    name: 'Satellite',
    icon: 'sl',
    link: 'https://stellabms.xyz/sl/table.html',
    colour: '#fffda4',
    folders: [
      { name: '0', start: 220, end: 255 },
      { name: '1', start: 255, end: 275 },
      { name: '2', start: 275, end: 300 },
      { name: '3', start: 300, end: 320 },
      { name: '4', start: 320, end: 340 },
      { name: '5', start: 340, end: 360 },
      { name: '6', start: 360, end: 380 },
      { name: '7', start: 380, end: 400 },
      { name: '8', start: 400, end: 420 },
      { name: '9', start: 420, end: 440 },
      { name: '10', start: 440, end: 460 },
      { name: '11', start: 460, end: 480 },
      { name: '12', start: 480, end: 490 },
    ],
  },
  {
    name: 'Stella',
    icon: 'st',
    isContinuation: true,
    link: 'https://stellabms.xyz/st/table.html',
    colour: '#fffb5f',
    folders: [
      { name: '0', start: 490, end: 510 },
      { name: '1', start: 510, end: 520 },
      { name: '2', start: 520, end: 530 },
      { name: '3', start: 530, end: 540 },
      { name: '4', start: 540, end: 560 },
      { name: '5', start: 560, end: 570 },
      { name: '6', start: 570, end: 590 },
      { name: '7', start: 590, end: 600 },
      { name: '8', start: 600, end: 610 },
      { name: '9', start: 610, end: 630 },
      { name: '10', start: 630, end: 640 },
      { name: '11', start: 640, end: 650 },
    ],
  },
  {
    name: 'Insane',
    icon: '★',
    link: 'https://darksabun.github.io/table/archive/insane1',
    colour: '#ffe0e0',
    folders: [
      { name: '1', start: 255, end: 265 },
      { name: '2', start: 265, end: 280 },
      { name: '3', start: 280, end: 290 },
      { name: '4', start: 290, end: 310 },
      { name: '5', start: 310, end: 320 },
      { name: '6', start: 320, end: 330 },
      { name: '7', start: 330, end: 340 },
      { name: '8', start: 340, end: 350 },
      { name: '9', start: 350, end: 360 },
      { name: '10', start: 360, end: 370 },
      { name: '11', start: 370, end: 385 },
      { name: '12', start: 385, end: 395 },
      { name: '13', start: 395, end: 410 },
      { name: '14', start: 410, end: 420 },
      { name: '15', start: 420, end: 430 },
      { name: '16', start: 430, end: 450 },
      { name: '17', start: 450, end: 470 },
      { name: '18', start: 470, end: 480 },
      { name: '19', start: 480, end: 500 },
      { name: '20', start: 500, end: 510 },
      { name: '21', start: 510, end: 520 },
      { name: '22', start: 520, end: 530 },
      { name: '23', start: 530, end: 550 },
      { name: '24', start: 550, end: 580 },
      { name: '25', start: 580, end: 620 },
    ],
  },
  {
    name: 'Overjoy',
    icon: '★★',
    link: 'http://lr2.sakura.ne.jp/overjoy.php',
    colour: '#ff7676',
    folders: [
      { name: '1', start: 510, end: 520 },
      { name: '2', start: 520, end: 530 },
      { name: '3', start: 530, end: 550 },
      { name: '4', start: 550, end: 580 },
      { name: '5', start: 580, end: 620 },
      { name: '6', start: 620, end: 640 },
      { name: '7', start: 640, end: 650 },
    ],
  },
];

class BmsDifficulties extends HTMLElement {
  constructor() {
    super();
  }

  render = async () => {
    const max = tables
      .reduce((acc, folder) => [...acc, ...folder.folders], [] as Folders[])
      .reduce((acc, level) => (level.end > acc ? level.end : acc), 0);

    let column = 0;

    this.innerHTML = '';
    this.append(
      <ul>
        {...tables.map((table) => (
          <li>
            <a
              className="tableLink externalLink"
              href={table.link}
              target="_blank"
              style={`--colour: ${table.colour}`}
            >
              {table.icon} - {table.name}
            </a>
          </li>
        ))}
      </ul>,
    );
    this.append(
      <div className="difficultyWrapper" style={`--max: ${max}`}>
        {...tables.flatMap((table) => {
          column += table.isContinuation ? 0 : 1;

          return [
            ...[
              table.folders[0].start !== 1 ? (
                <div
                  class="spacer"
                  style={`--start: 1; --end: ${table.folders[0].start}; --col: ${column};`}
                />
              ) : (
                ''
              ),
            ],
            ...table.folders.map((level) => (
              <div
                class="folder"
                style={`--start: ${level.start}; --end: ${level.end}; --col: ${column}; --colour: ${table.colour}`}
              >
                {table.icon}
                {level.name}
              </div>
            )),
            ...[
              table.folders[table.folders.length - 1].end !== max ? (
                <div
                  class="spacer"
                  style={`--start: ${table.folders[table.folders.length - 1].end}; --end: ${max}; --col: ${column};`}
                />
              ) : (
                ''
              ),
            ],
          ];
        })}
      </div>,
    );
  };

  connectedCallback() {
    void this.render();
  }
}

export default BmsDifficulties;
